<template>
  <component :is="tag">
    <template v-for="(str, index) in titleSplit">
      <template v-if="index % 2 === 0">{{ str }}</template>
      <component v-else :key="str" :is="highlightTag">{{ str }}</component>
    </template>
  </component>
</template>

<script>
export default {
  name: 'HighlightedTitle',
  props: {
    title: { type: String, default: '' },
    tag: { type: String, default: 'h2' },
    highlightTag: { type: String, default: 'em' },
  },
  computed: {
    titleSplit() {
      return this.title.split('*')
    },
  },
}
</script>
